import { createSelector } from 'reselect'

import { IAppState } from '../reducers';
import * as fromCity from '../reducers/city';
import * as fromConfig from '../reducers/config';
import * as fromScenarios from '../reducers/scenarios';

import { IDataPoint,  } from '../../services/projections';
import { IScenarioProps, SharingMode } from "../types/scenarios";

// Only store once per application load
export const CURRENT_YEAR = 2018 ; // new Date().getFullYear();
export const PROJECTION_START_YEAR = 2015; // all projections should be based off of 2015
export const PROJECTION_YEAR_DELTA = CURRENT_YEAR - PROJECTION_START_YEAR; // for GDP, Population, fill with 0

// Data scattered around the app...
export const getPopulation = (state: IAppState) => fromCity.getPopulation(state.city);
export const getPopulationGrowthRate = (state: IAppState) => fromCity.getPopulationGrowthRate(state.city);
export const getNumProjectionYears = (state: IAppState) => fromConfig.getNumProjectionYears(state.config);
export const getUserChoicePercentageBound = (state: IAppState) => fromCity.getUserChoicePercentageBound(state.city);
export const getPassengerDistanceTraveled = (state: IAppState) => fromCity.getPassengerDistanceTraveled(state.city);

// Booleans
export const getHasMajorHills = (state: IAppState) => {
  return fromCity.getHasMajorHills(state.city)
}

export const getHasCngRegulation = (state: IAppState) => {
  return fromCity.getHasCngRegulation(state.city)
}

// Modal split simple
export const getModalSplitByType = (state: IAppState) => fromCity.getModalSplitByType(state.city);
export const getModalSplitByOwnership = (state: IAppState) => fromCity.getModalSplitByOwnership(state.city);

// Scenarios
export const getScenarios = (state: IAppState) => fromScenarios.scenariosAsList(state.scenarios);

// GDP
export const getGrossDomesticProduct = (state: IAppState) => fromCity.getGrossDomesticProduct(state.city);
export const getEconomicGrowthRate = (state: IAppState) => fromCity.getEconomicGrowthRate(state.city);

/* Return the year for which projections are being made through */
export const getProjectionYear = createSelector(
  [getNumProjectionYears],
  (numProjectionYears): number => {
    return PROJECTION_START_YEAR + numProjectionYears;
  }
)

// Fetching data for specific goals... TBD if passengerDistance should be fetched like this //
// Electrification goals
export const getPrivateElectrificationVehicleGoal = (state: IAppState, props: IScenarioProps) => {
  return fromScenarios.getPrivateElectrificationVehicleGoal(state.scenarios, props);
}

export const getPublicCommercialElectrificationVehicleGoal = (state: IAppState, props: IScenarioProps) => {
  return fromScenarios.getPublicCommercialElectrificationVehicleGoal(state.scenarios, props);
}

// Modal Split Intensities
// TBD if these should just return numbers, or if these props get excessively re-rendered
// Used by top of page
export const getModalSplitNonMotorizedTransit = (state: IAppState, props: IScenarioProps) => ({
  name: 'non-motorized transit',
  value: fromScenarios.getModalSplitNonMotorizedTransit(state.scenarios, props)
})

export const getModalSplitPublicTransit = (state: IAppState, props: IScenarioProps) => ({
  name: 'public transit',
  value: fromScenarios.getModalSplitPublicTransit(state.scenarios, props)
})

export const getModalSplitSharedMobility = (state: IAppState, props: IScenarioProps) => ({
  name: 'shared mobility',
  value: fromScenarios.getModalSplitSharedMobility(state.scenarios, props)
})

// Some simpler selectors for the benefit of actual calculations
export const getModalSplitNonMotorizedTransitLever = (state: IAppState, props: IScenarioProps) => (
  fromScenarios.getModalSplitNonMotorizedTransit(state.scenarios, props)
)

export const getModalSplitPublicTransitLever = (state: IAppState, props: IScenarioProps) => (
  fromScenarios.getModalSplitPublicTransit(state.scenarios, props)
)

export const getModalSplitSharedMobilityLever = (state: IAppState, props: IScenarioProps) => (
  fromScenarios.getModalSplitSharedMobility(state.scenarios, props)
)

export const getSharingMode = (state: IAppState, props: IScenarioProps) => {
  const mode = fromScenarios.getModalSplitSharedMobility(state.scenarios, props)
  return fromScenarios.sharedMobilityLeverToSharingMode(mode);
}

export const getHasRenewableEnergyTarget = (state: IAppState, props: IScenarioProps) => {
  return fromScenarios.getHasRenewableEnergyTarget(state.scenarios, props)
}

// Get the name of the scenario key that goes with this component
export const getComponentKey = (state: IAppState, props: IScenarioProps) => (
  props.scenarioKey
)

// Domain agnostic utils
export const getLastSeriesValue = (series: IDataPoint[]) => {
  return series.slice(-1)[0].y;
}



// WEBPACK FOOTER //
// ./src/store/selectors/index.ts